import { ArrowRightIcon } from 'lucide-react'

import { Button, usePageTitle } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import { CenteredLayout } from '../employer_onboarding/CenteredLayout'

export function CompletePage () {
  usePageTitle('You\'re all set!')

  const { assign } = useWindowLocation()

  const handleBackToDashboard = () => {
    assign('/employers/employees')
  }

  return (
    <CenteredLayout>
      <CenteredLayout.Header
        heading="You're all set"
        subheading="We'll now send a confirmation email to each individual you added to collect additional information."
        align='center'
      />
      <CenteredLayout.Buttons align='center'>
        <Button
          variant='primary'
          onClick={handleBackToDashboard}
          rightIcon={ArrowRightIcon}
        >
          Back to dashboard
        </Button>
      </CenteredLayout.Buttons>
    </CenteredLayout>
  )
}
